import { ReactComponent as IconSvg } from './icon_text_resize.svg';
import Icon, { IconProps } from './icon';

const IconTextResize = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconTextResize;
